
import api from '../../api/rideInformation';
import { router } from '../../main';
import { handleGuiVersionOutdated } from '@/common/guiVersionHandler';
import { DEFAULT_DESIGN, resolveDesign } from '@/utils/rideDesigns';

const getDefaultRideLanguage = (appLanguage) => {
  return appLanguage === 'en' ? 'english' : 'hebrew';
};

const state = {
  rideInformationSherdPhotosAlbomLink: '',
  rideInformationTitle: '',
  rideInformationText: '',
  rideInformationId: null,
  rideInformationTopPageImageUrl: null,
  rideInformationCoverImageUrl: null,
  rideInformationVideoUrl: null,
  rideInformationAudioUrl: null,
  rideInformationMode: null,
  rideInformationCheckIn: null,
  rideInformationCheckOut: null,
  rideInformationNumbrOfAdoult: 0,
  rideInformationNumbrOfTeen: 0,
  rideInformationNumbrOfChild: 0,
  rideInformationPhysicalDisabilities: false,
  rideInformationPublick: true,
  rideInformationSubdomain: false,
  rideInformationIsLocked: false,
  originalRideInformationCheckIn: null,
  rideInformationLanguage: 'hebrew', // Default to Hebrew
  rideInformationAiTripProfile: {},
  rideInformationPresentationDesign: DEFAULT_DESIGN,
};

const getters = {
  rideInformationSherdPhotosAlbomLink: state => state.rideInformationSherdPhotosAlbomLink,
  rideInformationTitle: state => state.rideInformationTitle,
  rideInformationText: state => state.rideInformationText,
  rideInformationId: state => state.rideInformationId,
  rideInformationMode: state => state.rideInformationMode,
  rideInformationCheckIn: state => state.rideInformationCheckIn,
  rideInformationCheckOut: state => state.rideInformationCheckOut,
  rideInformationTopPageImageUrl: state => state.rideInformationTopPageImageUrl,
  rideInformationCoverImageUrl: state => state.rideInformationCoverImageUrl,
  rideInformationVideoUrl: state => state.rideInformationVideoUrl,
  rideInformationAudioUrl: state => state.rideInformationAudioUrl,
  isRideInformationEditMode: state => !!state.rideInformationId,
  rideInformationNumbrOfAdoult: state => state.rideInformationNumbrOfAdoult,
  rideInformationNumbrOfTeen: state => state.rideInformationNumbrOfTeen,
  rideInformationNumbrOfChild: state => state.rideInformationNumbrOfChild,
  rideInformationPhysicalDisabilities: state => state.rideInformationPhysicalDisabilities,
  rideInformationPublick: state => state.rideInformationPublick,
  rideInformationSubdomain: state => state.rideInformationSubdomain,
  rideInformationIsLocked: state => state.rideInformationIsLocked,
  rideInformationLanguage: state => state.rideInformationLanguage,
  rideInformationAiTripProfile: state => state.rideInformationAiTripProfile,
  rideInformationPresentationDesign: state => state.rideInformationPresentationDesign,
  
};

const actions = {
  rideInformationLoadDefault({ commit, rootGetters }) {
    commit('setRideInformationId', null);
    commit('setRideInformationTitle', '');
    commit('setRideInformationSherdPhotosAlbomLink', '');
    commit('setRideInformationText', '');
    commit('setRideInformationTopPageImageUrl', null);
    commit('setRideInformationCoverImageUrl', null);
    commit('setRideInformationVideoUrl', null);
    commit('setRideInformationAudioUrl', null);
    commit('setRideInformationMode', null);
    commit('setRideInformationCheckIn', null);
    commit('setRideInformationCheckOut', null);
    commit('setOriginalRideInformationCheckIn', null);
    commit('setRiderideInformationNumbrOfAdoult', 0);
    commit('setRideRideInformationNumbrOfTeen', 0);
    commit('setRideRideInformationNumbrOfChild', 0);
    commit('setRideRideInformationPhysicalDisabilities', false);
    commit('setRideInformationPublick', true);
    // Set default value to true if user is a subdomain manager
    const isUserSubdomainManager = rootGetters.isUserSubdomainManager;
    commit('setRideInformationSubdomain', isUserSubdomainManager);
    commit('setRideInformationIsLocked', false);
    const currentAppLanguage = rootGetters['language/getCurrentLanguage'];
    const defaultRideLanguage = getDefaultRideLanguage(currentAppLanguage);
    commit('setRideInformationLanguage', defaultRideLanguage);
    commit('setRideInformationAiTripProfile', {});
    commit('setRideInformationPresentationDesign', DEFAULT_DESIGN);
    
  },

  // getDatePickarFormat( {} ){
  //   return "{ mode: 'range', dateFormat:'d-m-Y' }"
  // },
  async openRideInformationPage({ dispatch, rootState }, rideId=null ) {
    const { apptoken } = rootState.appauth;
    await dispatch('rideInformationLoadDefault');
    if (apptoken) {
      if ( rideId ){
        await dispatch( 'loadRideInformation', rideId )
      }
      else{
        router.push('/add_images')
        return
      }
      router.push('/ride_information')
    }
    else{
      dispatch('openLoginForm');
    }
  },

  async loadRideInformation({ commit, dispatch, rootState }, rideId ) {
    await dispatch('rideInformationLoadDefault');
    const { apptoken } = rootState.appauth;
    const response = await api.getRideInformation(apptoken,
      rideId);
    const data = response.data.rideInformation;
    commit('setRideInformationId', rideId );
    commit('setRideInformationTitle', data.title);
    commit('setRideInformationSherdPhotosAlbomLink', data.photos_albom_link);
    commit('setRideInformationText', data.text);
    commit('setRideInformationTopPageImageUrl', data.top_page_image_url || null);
    commit('setRideInformationCoverImageUrl', data.cover_image_url || null);
    commit('setRideInformationVideoUrl', data.video_url || null);
    commit('setRideInformationAudioUrl', data.audio_url || null);
    commit('setRideInformationCheckIn', data.start_date);
    commit('setRideInformationCheckOut', data.end_date);
    commit('setOriginalRideInformationCheckIn', data.start_date);
    commit('setRiderideInformationNumbrOfAdoult', data.number_of_adult);
    commit('setRideRideInformationNumbrOfTeen', data.number_of_teen);
    commit('setRideRideInformationNumbrOfChild', data.number_of_child);
    commit('setRideRideInformationPhysicalDisabilities', data.physical_disabilities);
    commit('setRideInformationSubdomain', data.is_white_label);
    commit('setRideInformationIsLocked', data.is_locked || false);
    // Load language from server, default to 'hebrew' if not provided
    commit('setRideInformationLanguage', data.language || 'hebrew');
    commit('setRideInformationAiTripProfile', data.ai_trip_profile || {});
    commit('setRideInformationPresentationDesign', data.presentation_design);

  },

  async updateRideInformationWithoutPushingToRide({ dispatch }) {
    await dispatch('updateRideInformationOnly');
  },

  async updateRideInformation({ getters, dispatch }) {    
    const rideInformationId = getters.rideInformationId;
    dispatch('showModal', "loadingIcon");
    const success = await dispatch('updateRideInformationOnly');
    if (success === false) {
      return;
    }
    dispatch('showModal', "");
    router.push('/single_ride_with_map/' + rideInformationId);
  },
  async lockRide({ rootState, commit, dispatch }, { rideId, isLocked }) {
    const { apptoken } = rootState.appauth;
    const response = await api.lockRide(apptoken, rideId, isLocked);
  
    if (response.data.ServerMassageCode !== "success") {
      dispatch('showModalWithParameters', {
        errorNumber: response.data.ServerMassageCode,
        type: 'textConverter'
      });
      throw new Error('Failed to lock/unlock ride');
    }
    
    // Update local state
    commit('setRideInformationIsLocked', isLocked);
    
    // Refresh ride header to update lock status across the app
    if (rootState.ride.lowedRideId === rideId || rootState.ride.rideId === rideId) {
      await dispatch('fetchRideHeaderInformation', null, { root: true });
    }
    
    return response;
  },
  async updateRideInformationOnly({ state, rootState, getters, dispatch }, { force = false } = {}) {
    var rideInformation = {}
    rideInformation['title'] = state.rideInformationTitle;
    rideInformation['photos_albom_link'] = state.rideInformationSherdPhotosAlbomLink;
    rideInformation['text'] = state.rideInformationText;
    rideInformation['top_page_image_url'] = state.rideInformationTopPageImageUrl;
    rideInformation['cover_image_url'] = state.rideInformationCoverImageUrl;
    rideInformation['video_url'] = state.rideInformationVideoUrl;
    rideInformation['audio_url'] = state.rideInformationAudioUrl;
    rideInformation['checkIn'] = state.rideInformationCheckIn.toString();
    rideInformation['number_of_adult'] = state.rideInformationNumbrOfAdoult;
    rideInformation['number_of_teen'] = state.rideInformationNumbrOfTeen;
    rideInformation['number_of_child'] = state.rideInformationNumbrOfChild;
    rideInformation['physical_disabilities'] = state.rideInformationPhysicalDisabilities.toString();
    rideInformation['is_subdomain'] = state.rideInformationSubdomain.toString();
    rideInformation['language'] = state.rideInformationLanguage;
    rideInformation['presentation_design'] = state.rideInformationPresentationDesign;
    const rideInformationId = getters.rideInformationId;
    const { apptoken } = rootState.appauth;
    const response = await api.updateRideInformation(apptoken,
      rideInformationId,
      rideInformation,
      force);
    
    // Return false if there's an error
    if( response.data.ServerMassageCode != "secsses" ){
      // If the server reports a GUI version mismatch, show message then redirect or reload
      if( response.data.ServerMassageCode === 'gui_version_outdated' ){
        handleGuiVersionOutdated({ dispatch, rideInformationId });
        return false;
      }
      // If we get ordered accommodation error and force is false, show confirmation modal
      if( response.data.ServerMassageCode == "rideHaveOrderedAccommodation" && !force ){
        dispatch( 'showModalWithParameters',
                   { inerModalParameters: { rideInformationId: rideInformationId },
                     type:'confirmForceUpdateRideInformation' 
                   } );
        return false;
      }
      
      // For other errors, show the error message
      dispatch( 'showModalWithParameters',
                { errorNumber : response.data.ServerMassageCode,
                  type:'textConverter' 
                } );
      return false;
    }
    
    await dispatch('rideInformationLoadDefault');
    
    // Return true on success
    return true;
  },

  async createRideInformation({ state, rootState, dispatch }, payload = {}) {
    var rideInformation = {}
    rideInformation['title'] = state.rideInformationTitle;
    rideInformation['photos_albom_link'] = state.rideInformationSherdPhotosAlbomLink;
    rideInformation['text'] = state.rideInformationText;
    rideInformation['checkIn'] = state.rideInformationCheckIn.toString();
    rideInformation['checkOut'] = state.rideInformationCheckOut.toString();
    rideInformation['number_of_adult'] = state.rideInformationNumbrOfAdoult;
    rideInformation['number_of_teen'] = state.rideInformationNumbrOfTeen;
    rideInformation['number_of_child'] = state.rideInformationNumbrOfChild;
    rideInformation['physical_disabilities'] = state.rideInformationPhysicalDisabilities.toString();
    rideInformation['is_publick'] = state.rideInformationPublick.toString();
    rideInformation['is_subdomain'] = state.rideInformationSubdomain.toString();
    rideInformation['language'] = state.rideInformationLanguage;
    const { apptoken } = rootState.appauth;
    dispatch( 'showModal', "loadingIcon" );
    const response = await api.setRideInformation(apptoken,
      rideInformation);
    dispatch( 'showModal', "" );
    if (response.status === 200) {
      await dispatch('rideInformationLoadDefault');    // set the ride id to lowad
      if (payload.isFirstRide) {
        router.push('/after-first-ride/' + response.data.rideId);
      } else {
        router.push('/single_ride_with_map/' + response.data.rideId);
      }
    }
    // dispatch( 'lockShowModalOnce' );
  },
};

const mutations = {
  setRideInformationSherdPhotosAlbomLink: (state, rideInformationSherdPhotosAlbomLink) => {
    state.rideInformationSherdPhotosAlbomLink = rideInformationSherdPhotosAlbomLink;
  },
  setRideInformationTitle: (state, rideInformationTitle) => {
    state.rideInformationTitle = rideInformationTitle;
  },
  setRideInformationText: (state, rideInformationText) => {
    state.rideInformationText = rideInformationText;
  },
  setRideInformationTopPageImageUrl: (state, rideInformationTopPageImageUrl) => {
    state.rideInformationTopPageImageUrl = rideInformationTopPageImageUrl;
  },
  setRideInformationCoverImageUrl: (state, url) => {
    state.rideInformationCoverImageUrl = url;
  },
  setRideInformationVideoUrl: (state, url) => {
    state.rideInformationVideoUrl = url;
  },
  setRideInformationAudioUrl: (state, url) => {
    state.rideInformationAudioUrl = url;
  },
  setRideInformationCheckIn: (state, rideInformationCheckIn) => {
    state.rideInformationCheckIn = rideInformationCheckIn;
  },
  setRideInformationCheckOut: (state, rideInformationCheckOut) => {
    state.rideInformationCheckOut = rideInformationCheckOut;
  },
  setRideInformationId: (state, rideInformationId) => {
    state.rideInformationId = rideInformationId;
  },
  setRideInformationMode: (state, mode) => {
    state.rideInformationMode = mode;
  },
  setRiderideInformationNumbrOfAdoult: (state, rideInformationNumbrOfAdoult) => {
    state.rideInformationNumbrOfAdoult = rideInformationNumbrOfAdoult;
  },
  setRideRideInformationNumbrOfTeen: (state, rideInformationNumbrOfTeen) => {
    state.rideInformationNumbrOfTeen = rideInformationNumbrOfTeen;
  },
  setRideRideInformationNumbrOfChild: (state, rideInformationNumbrOfChild) => {
    state.rideInformationNumbrOfChild = rideInformationNumbrOfChild;
  },
  setRideRideInformationPhysicalDisabilities: (state, rideInformationPhysicalDisabilities) => {
    state.rideInformationPhysicalDisabilities = rideInformationPhysicalDisabilities;
  },
  setRideInformationPublick: (state, rideInformationPublick) => {
    state.rideInformationPublick = rideInformationPublick;
  },
  setRideInformationSubdomain: (state, rideInformationSubdomain) => {
    state.rideInformationSubdomain = rideInformationSubdomain;
  },
  setRideInformationIsLocked: (state, rideInformationIsLocked) => {
    state.rideInformationIsLocked = rideInformationIsLocked;
  },
  setOriginalRideInformationCheckIn: (state, originalRideInformationCheckIn) => {
    state.originalRideInformationCheckIn = originalRideInformationCheckIn;
  },
  setRideInformationLanguage: (state, rideInformationLanguage) => {
    state.rideInformationLanguage = rideInformationLanguage;
  },
  setRideInformationAiTripProfile: (state, profile) => {
    state.rideInformationAiTripProfile = profile || {};
  },
  setRideInformationPresentationDesign: (state, design) => {
    state.rideInformationPresentationDesign = resolveDesign(design);
  },


};

export default {
  state,
  getters,
  actions,
  mutations
};
